import {
  format,
  formatDistanceToNow,
  differenceInDays,
  differenceInWeeks,
  differenceInMonths,
  differenceInYears,
} from "date-fns";
import { ro } from "date-fns/locale";

function timeAgo(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();

  // Get the time difference in days, weeks, months, and years
  const diffDays = differenceInDays(now, date);
  const diffWeeks = differenceInWeeks(now, date);
  const diffMonths = differenceInMonths(now, date);
  const diffYears = differenceInYears(now, date);

  // Less than 24 hours
  if (diffDays < 1) {
    return formatDistanceToNow(date, { addSuffix: true, locale: ro });
  }

  // Less than a week
  if (diffWeeks < 1) {
    if (diffDays === 1) {
      return `În urmă cu 1 zi`;
    }
    return `Cu ${diffDays} zile în urmă`;
  }

  // Less than a month
  if (diffMonths < 1) {
    if (diffWeeks === 1) {
      return `În urmă cu 1 săptămână`;
    }
    return `Cu ${diffWeeks} săptămâni în urmă`;
  }

  // Less than a year
  if (diffYears < 1) {
    if (diffMonths === 1) {
      return `În urmă cu 1 lună`;
    }
    return `Cu ${diffMonths} luni în urmă`;
  }

  // More than a year, display the exact date
  return format(date, "dd.MM.yyyy", { locale: ro });
}

export default timeAgo;
